import React from 'react'
import CalculatorInput from 'components/CalculatorInput'
import { connect } from 'react-redux'
import { updateCalculatorAction as callback } from 'actions/calculatorActions'
import { updateUiAction } from 'actions/uiActions'
import injectSheet from 'react-jss'
import style from './style'
import getCurrentCamera from 'helpers/cameras/getCurrentCamera'
import FocalLengthContainer from 'components/FocalLengthContainer'
import ImagerSizeContainer from 'components/ImagerSizeContainer'
import { IMAGER_SIZES } from 'helpers/globals'
import CalculatorSelect from 'components/CalculatorSelect'
import { updateCalculatorAction } from 'actions/calculatorActions'

const mapStateToProps = ({ presentationValues, cameras, projects, ui: { showAnalyticZones, isImperial } }) => {
  return {
    presentationValues,
    projects,
    isImperial,
    currentCamera: getCurrentCamera(cameras),
    showAnalyticZones
  }
}

const focalLengthDisplay = (fl, aov) => aov === 360 ? '0.0' : fl

const AdvancedPanelContainer =
    ({ presentationValues: { focalLength },
       callback, currentCamera, currentCamera: { imagerSize, displayIrLine, id, model }, updateCalculatorAction, classes, updateUiAction, isImperial, showAnalyticZones
    }) =>
      <div className={classes.container}>
        <div>Lens Settings</div>
        <div className={classes.leftSide}>
          <ImagerSizeContainer
            statelessComponent={
              <CalculatorSelect
                currentCamera={currentCamera}
                label='Imager'
                titleTag='Imager Size'
                selectedValue={imagerSize}
                values={IMAGER_SIZES}
                fnKey='imagerSize'
                callback={callback}
                labelClass='extraWideLabel'
              />
            }
            currentCamera={currentCamera}
          />
        </div>
        <div className={classes.halfWidth}>
          <FocalLengthContainer
            currentCamera={currentCamera}
            >
            <CalculatorInput
              currentCamera={currentCamera}
              label='Focal Length'
              value={focalLengthDisplay(focalLength.value, currentCamera.horizontalAngleOfView)}
              fnKey={'focalLength'}
              unit={'mm'}
              callback={callback}
              labelClass='extraWideLabel'
              rawValue={currentCamera.focalLength}
            />
          </FocalLengthContainer>
        </div>
        {model && model.infrared > 0 &&
          <div className={classes.displayOverlay}>
            <label>
              <input
                type='checkbox'
                checked={displayIrLine}
                onChange={({ target: { checked } }) => updateCalculatorAction(checked, 'displayIrLine', id, false)}
              /> Display IR Spec Range
            </label>
          </div>
        }
        <div className={classes.displayOverlay}>
          <label>
            <input
              type='checkbox'
              checked={showAnalyticZones}
              onChange={updateUiAction.bind(null, { showAnalyticZones: !showAnalyticZones })}
            /> Display {isImperial ? 'PPF' : 'PPM'} Zones
          </label>
        </div>
      </div>

export default connect(mapStateToProps, { callback, updateCalculatorAction, updateUiAction })(injectSheet(style)(AdvancedPanelContainer))



// WEBPACK FOOTER //
// ./src/components/AdvancedPanelContainer/index.js